import { tr } from 'mmfintech-commons'
import { PaymentMethods, useCheckoutPolling } from 'mmfintech-checkout-commons'

import { PreviewPayId } from './PreviewPayId'
import { PreviewContainer } from '../PreviewBankwire/PreviewBankwire.styled'
import { InstructionsContainer } from './PreviewInstructions.styled'

import type {
  BaseInstructionsResult,
  FawryPayInstructionsResult,
  FlutterwaveMobileAppInstructionsResult
} from 'mmfintech-checkout-commons/types'

interface PreviewInstructionsProps {
  sessionId?: string
  result: BaseInstructionsResult
}

export const PreviewInstructions = ({ sessionId, result }: PreviewInstructionsProps) => {
  const { paymentMethod } = result || {}

  const { startPolling } = useCheckoutPolling({
    sessionId,
    pollingInterval: 5000,
    maxPollCount: 60
  })

  if (paymentMethod === PaymentMethods.PAY_ID) {
    startPolling()
    return (
      <PreviewContainer>
        <PreviewPayId result={result || '123456789'} />
      </PreviewContainer>
    )
  }

  if (paymentMethod === PaymentMethods.FAWRY_PAY) {
    const { instructions } = result as FawryPayInstructionsResult
    return (
      <PreviewContainer>
        <InstructionsContainer>{instructions || 'Instructions'}</InstructionsContainer>
      </PreviewContainer>
    )
  }

  if (paymentMethod === PaymentMethods.M_PESA) {
    startPolling()
    const { phoneNumber } = result as FlutterwaveMobileAppInstructionsResult
    return (
      <PreviewContainer>
        <InstructionsContainer>
          {tr(
            'CHECKOUT.INSTRUCTIONS.MPESA',
            'You will receive a prompt on mobile number {{phone_number}} to enter your MPESA service PIN to authorize your payment request.',
            { phone_number: phoneNumber }
          )}
        </InstructionsContainer>
      </PreviewContainer>
    )
  }

  if (paymentMethod === PaymentMethods.MOBILE_MONEY) {
    startPolling()
    const { phoneNumber } = result as FlutterwaveMobileAppInstructionsResult
    return (
      <PreviewContainer>
        <InstructionsContainer>
          {tr(
            'CHECKOUT.INSTRUCTIONS.MOBILE_MONEY',
            'You will receive a prompt on mobile number {{phone_number}} to enter your Mobile Money service PIN to authorize your payment request.',
            { phone_number: phoneNumber }
          )}
        </InstructionsContainer>
      </PreviewContainer>
    )
  }

  return (
    <PreviewContainer>
      <InstructionsContainer>Something went wrong</InstructionsContainer>
    </PreviewContainer>
  )
}
